module.exports = __webpack_public_path__ + "static/media/down_arrow.45004ab3.svg";